import React from "react";

import "@/base/styles/globals.scss";
import { appWithTranslation } from "next-i18next";
import { ThemeProvider } from "next-themes";
import "@/styles/globals.scss";

import App, { Props } from "@/base/pages/_app";
import nextI18NextConfig from "./../../next-i18next.config.js";
import MontserratFontLoader from "@/base/components/util/MontserratFontLoader";

const ThemedApp = ({ Component, pageProps }: Props) => {
    const defaultTheme = process.env.NEXT_PUBLIC_DEFAULT_THEME || "light";
    return (
        <ThemeProvider attribute={"class"} defaultTheme={defaultTheme} themes={[...(process.env.NEXT_PUBLIC_THEMES ? [...process.env.NEXT_PUBLIC_THEMES.split(","), defaultTheme] : [defaultTheme])]}>
            <MontserratFontLoader />
            <App
                Component={Component}
                pageProps={{
                    ...pageProps,
                    defaultTheme,
                }}
            />
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap" rel="stylesheet" />
        </ThemeProvider>
    );
};

export default appWithTranslation(ThemedApp, nextI18NextConfig);
